import React from 'react'
import ReactModal from 'react-modal'

import Title from '@/components/Title'
import TextBody from '@/components/TextBody/TextBody'

import styles from './FinancingModal.module.scss'
import { FINANCING_OPTIONS } from 'const'

export type FinancingModalProps = {
  isOpen: boolean
  onClose: () => void
  option: 'affirm' | 'credova' | 'terrace' | 'mawoo' | 'acorn'
}

export const FinancingModal = ({
  isOpen,
  onClose,
  option,
}: FinancingModalProps) => {
  const _option: {
    image: string
    subtitle: string
    items: { icon: string; title: string; subtitle: string }[]
    link: string
    color: string
    buttonLabel: string
  } = FINANCING_OPTIONS[option]
  return (
    <ReactModal
      {...{ isOpen }}
      overlayClassName={styles.modalOverlay}
      className={styles.modal}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
    >
      <div className={styles.closeButton} onClick={onClose}>
        <img src="/terrace-modal/close.svg" alt="close icon" />
      </div>

      <div className={styles.header}>
        <img
          className={styles.logo}
          src={_option.image}
          alt="financing option"
        />

        <Title variant="h3">{_option.subtitle}</Title>
      </div>

      <div className={styles.content}>
        <Title variant="h2">How It Works:</Title>

        {_option.items.map((i, index) => (
          <div key={index} className={styles.item}>
            <img src={i.icon} alt={`icon-${index}`} />

            <div className={styles.text}>
              <TextBody size="m" weight="bold">
                {i.title}
              </TextBody>

              <TextBody size="m">{i.subtitle}</TextBody>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={() => {
          if (_option.link.startsWith('tel:')) {
            window.location.href = _option.link
          } else {
            window.open(_option.link)
          }
          onClose()
        }}
        style={{ backgroundColor: _option.color }}
      >
        {_option.buttonLabel}
      </button>
    </ReactModal>
  )
}

export default FinancingModal
